var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrophone = function SvgMicrophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 320,
    viewBox: "0 0 344 320",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kky6zyh4aa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E7F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4bf6pm0kkb",
    x1: "50%",
    x2: "50%",
    y1: "31.091%",
    y2: "158.789%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E1EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mftjmo2qcc",
    x1: "50%",
    x2: "50%",
    y1: "31.091%",
    y2: "158.789%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E1EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "91b8gvtged",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "131.443%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAF66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ujhcjrzz0e",
    x1: "50%",
    x2: "50%",
    y1: "-104.401%",
    y2: "193.857%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFA34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jkdr2k6lsg",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "150.297%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ACC0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6E1EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6et3t5vl0i",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "117.986%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAF66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w6zoxl59pm",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DCEEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B6D9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y05kthhlko",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "137.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBE1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yo4rlvrxet",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "137.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBE1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puxnevik0u",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "137.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBE1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zqdwwatawv",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "262.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#85BFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BBE1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yj39lwbxyw",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "262.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#85BFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BBE1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj72msesfx",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "262.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#85BFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BBE1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2hvmhbuegy",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "262.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#85BFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BBE1FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jgh6vykf2D",
    x1: "50%",
    x2: "50%",
    y1: "-56.315%",
    y2: "157.705%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8DD1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#54A5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ubgtv7dl4E",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "131.443%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFAF66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y53p47kbzG",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "137.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBE1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85BFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ohi5cnejfI",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAC0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F28CA6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "31r2jcmhff",
    d: "M0.126 0.276L48.959 0.276 48.959 8.661 0.126 8.661z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l8804q1clj",
    d: "M0.281 0.196L1.495 0.196 1.495 0.44 0.281 0.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9usb380otl",
    d: "M0.151 0.196L56.353 0.196 56.353 62.418 0.151 62.418z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n37qxoo6mp",
    d: "M0.359 0.196L0.815 0.196 0.815 0.424 0.359 0.424z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ejze2ksbdr",
    d: "M0.036 0.196L0.491 0.196 0.491 0.456 0.036 0.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k8cuux369z",
    d: "M0.301 0.196L1.583 0.196 1.583 0.442 0.301 0.442z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0a0xxsoahB",
    d: "M0.454 0.196L0.91 0.196 0.91 0.46 0.454 0.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ncj0mcfs3F",
    d: "M0.369 0.196L4.676 0.196 4.676 23.952 0.369 23.952z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.801
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F2FE",
    d: "M152.72 73.106c-21.773 6.413-51.196-3.602-71.836-3.15-19.082.418-38.627 6.868-51.845 20.654-6.204 6.472-10.849 14.362-13.967 22.77-7.043 18.993-5.598 42.055 7.552 57.451 16.429 19.233 44.62 21.45 68.654 29.28 17.796 5.798 34.361 15.36 48.29 27.875 6.645 5.97 12.822 12.693 20.71 16.882 11.01 5.847 24.512 6.05 36.288 1.969 11.777-4.082 21.903-12.148 29.845-21.765 12.004-14.535 19.706-32.965 34.756-44.307 8.654-6.522 19.867-10.918 24.494-20.723 1.709-3.619 2.32-7.69 2.218-11.69-.454-17.774-13.886-32.022-24.254-46.456-9-12.528-16.145-26.392-21.13-40.994-4.704-13.78-8.025-29.088-18.894-38.763-17.549-15.621-30.665 8.836-38.252 21.44-5.308 8.816-12.174 16.691-20.183 23.15-3.72 2.997-7.917 5.042-12.446 6.377",
    opacity: 0.318,
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) scale(-1 1) rotate(-3 0 5838.412)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F2FE",
    d: "M323.254 163.724c-4.583-2.807-8.981-5.67-10.682-10.601-1.748-5.073.103-10.586 1.552-15.752 7.447-26.554-13.536-52.758-40.922-38.198-9.73 5.174-17.127 14.67-27.707 17.74-16.752 4.858-33.03-5.588-48.94-8.703-17.457-3.416-36.62 5.525-45.265 21.117-2.76 4.98-4.517 10.5-7.574 15.304-7.297 11.47-23.443 15.672-36.371 16.137-5.235.188-10.538-.496-15.679.51-6.218 1.215-11.683 4.792-16.97 8.294-13.685 9.065-23.258 24.164-22.993 41.115.235 15.047 8.94 29.167 20.934 38.207 11.993 9.038 26.934 13.45 41.85 15.047 5.88.63 11.942.884 17.353 3.275 9.76 4.314 8.146 11.416 10.815 19.796 1.797 5.64 5.075 10.912 9.821 14.432 6.586 4.882 15.244 5.947 23.428 5.67 8.051-.272 16.52-1.896 22.54-7.266 5.705-5.087 8.607-13.008 14.971-17.231 7.576-5.028 17.663-3.322 26.307-.527 15.41 4.987 30.778 12.96 46.849 10.978 18.052-2.226 33.326-18.592 34.352-36.807.195-3.463-.107-7.078-1.789-10.106-4.711-8.482-14.122-15.565-10.17-26.852 2.97-8.493 14.202-11.583 20.804-16.521 10.159-7.597 11.029-24.767 1.692-33.358-2.398-2.208-5.34-3.942-8.206-5.7",
    opacity: 0.33,
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) scale(-1 1) rotate(20 0 -903.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F2FE",
    d: "M278.49 60.802c5.326-13.21-1.065-28.247-14.275-33.587-13.21-5.341-37.418-2.673-42.744 10.536-5.328 13.21 15.084 22.288 24.076 33.346 12.544 15.421 27.616 2.914 32.943-10.295",
    opacity: 0.33,
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) scale(-1 1) rotate(-60 0 485.273)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF2F6",
    d: "M111.059 58.102c-3.248-4.125-9.23-4.838-13.361-1.591-4.131 3.246-7.718 11.478-4.47 15.603 3.247 4.126 9.895-.738 15.08-1.588 7.234-1.185 5.998-8.298 2.75-12.424",
    opacity: 0.412,
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) scale(1 -1) rotate(-15 -384.19 0)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M336.138 238.836c0 1.819-1.475 3.294-3.294 3.294s-3.294-1.475-3.294-3.294c0-1.82 1.475-3.294 3.294-3.294 1.82 0 3.294 1.475 3.294 3.294M228.281 3.674c0 1.82-1.475 3.294-3.294 3.294s-3.293-1.475-3.293-3.294S223.168.38 224.987.38c1.82 0 3.294 1.475 3.294 3.294",
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3796F6",
    d: "M344.404 106.706c0 1.82-1.475 3.294-3.294 3.294-1.82 0-3.294-1.475-3.294-3.294 0-1.82 1.475-3.294 3.294-3.294s3.294 1.475 3.294 3.294",
    opacity: 0.344,
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M7.404 83.706C7.404 85.526 5.929 87 4.11 87 2.29 87 .816 85.525.816 83.706c0-1.82 1.475-3.294 3.294-3.294s3.294 1.475 3.294 3.294",
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3796F6",
    d: "M60.404 208.706c0 1.82-1.475 3.294-3.294 3.294-1.82 0-3.294-1.475-3.294-3.294 0-1.82 1.475-3.294 3.294-3.294s3.294 1.475 3.294 3.294M247.286 248.765c0 .682-.553 1.235-1.235 1.235s-1.235-.553-1.235-1.235.553-1.235 1.235-1.235 1.235.553 1.235 1.235",
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M61.14 27.48c-.427 2-2.396 3.276-4.397 2.849-2.001-.427-3.277-2.396-2.85-4.397.428-2.001 2.396-3.277 4.397-2.85 2.002.428 3.277 2.396 2.85 4.397M137.145 304.068c-.427 2.001-2.396 3.277-4.397 2.85-2.001-.428-3.277-2.397-2.85-4.397.428-2.002 2.396-3.278 4.397-2.85 2.002.427 3.277 2.396 2.85 4.397",
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3796F6",
    d: "M254.707 45.418c-.23 1.08-1.293 1.768-2.373 1.537-1.08-.23-1.768-1.293-1.538-2.372.231-1.08 1.294-1.77 2.374-1.538 1.079.23 1.768 1.293 1.537 2.373",
    transform: "translate(-18 -141) translate(16 141) matrix(-1 0 0 1 366.962 0) matrix(-1 0 0 1 366 0) matrix(1 0 0 -1 .222 307)"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#kky6zyh4aa)",
    d: "M168.466 73.15c-12.794-24.594-36.806-42.905-66.335-47.206C53.35 18.838 8.049 52.622.944 101.4-6.162 150.18 27.622 195.483 76.4 202.588c48.779 7.105 94.082-26.678 101.187-75.457 2.755-18.917-.66-37.298-8.693-53.145l-.429-.836z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4bf6pm0kkb)",
    d: "M61.854 75.72L75.296 75.72 75.296 70.424 61.854 70.424zM4.715 75.72L18.157 75.72 18.157 70.424 4.715 70.424z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#mftjmo2qcc)",
    d: "M35.57 140.977L44.512 140.977 44.512 109.87 35.57 109.87z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#91b8gvtged)",
    d: "M53.282 145.024c-.798-3.04-3.557-5.286-6.848-5.286H33.881c-3.291 0-6.05 2.246-6.848 5.286l-1.994 8.168 5.014-.513.319-.448 8.627.192v.052l1.158-.026 1.159.026v-.052l8.627-.192.319.448 5.014.513-1.994-8.168z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ujhcjrzz0e)",
    d: "M32.551 102.687v13.561c0 2.924 2.37 5.295 5.295 5.295h4.39c2.925 0 5.295-2.37 5.295-5.295v-13.561h-14.98z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(15.499 150.883)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i9py17hohh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#31r2jcmhff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jkdr2k6lsg)",
    d: "M41.872.276H7.214C3.299.276.126 3.449.126 7.364V8.66H48.96V7.364c0-3.915-3.173-7.088-7.087-7.088",
    mask: "url(#i9py17hohh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#6et3t5vl0i)",
    d: "M34.94 103.088h-.756c-17.96 0-32.972-14.027-34.178-31.934L0 70.971v-8.563c0-1.51 1.225-2.735 2.735-2.735 1.51 0 2.735 1.225 2.735 2.735v8.469c1.058 15.002 13.653 26.74 28.714 26.74h11.084c15.06 0 27.656-11.738 28.714-26.74v-8.469c0-1.51 1.225-2.735 2.735-2.735 1.511 0 2.735 1.225 2.735 2.735l-.006 8.746c-1.206 17.907-16.22 31.934-34.178 31.934H34.94z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M27.232 1.9c.717-.285 1.451-.536 2.2-.752-.749.216-1.483.467-2.2.752",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(34.644)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mihbxb14xk",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l8804q1clj"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M.28.227c.403-.02.808-.03 1.215-.03-.407 0-.812.01-1.214.03",
    mask: "url(#mihbxb14xk)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M53.1 1.948c.358.144.71.297 1.06.458-.35-.161-.702-.313-1.06-.458M50.896 1.181c.75.221 1.485.477 2.203.767-.718-.29-1.453-.546-2.203-.767M12.003 70.127h.013l-.013-.001v.001zM26.172 2.352c.348-.16.702-.31 1.059-.451-.357.142-.71.292-1.06.45M25.132 2.854c.34-.174.684-.341 1.033-.5-.35.16-.693.326-1.033.5",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(11.852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "882ri3us6n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9usb380otl"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w6zoxl59pm)",
    d: "M56.215 62.408c.033 0 .064.008.098.01v-4.042H32.608c-1.19 0-2.153-.964-2.153-2.153 0-1.19.964-2.153 2.153-2.153h23.705v-4.283H32.608c-1.19 0-2.153-.964-2.153-2.153 0-1.19.964-2.153 2.153-2.153h23.705v-4.358H32.608c-1.19 0-2.153-.964-2.153-2.153 0-1.19.964-2.153 2.153-2.153h23.705v-4.283H32.608c-1.19 0-2.153-.964-2.153-2.153 0-1.19.964-2.153 2.153-2.153h23.7l.005.07v-4.79h.04c-.325-9.372-5.987-17.385-14.04-21.1.35.162.696.331 1.037.509v18.875c0 1.19-.964 2.154-2.153 2.154-1.19 0-2.153-.964-2.153-2.154V1.181C37.664.774 36.232.487 34.76.332V21.8c0 1.188-.964 2.152-2.153 2.152-1.19 0-2.153-.964-2.153-2.152V.196h-4.283v21.596c0 1.19-.964 2.154-2.153 2.154-1.19 0-2.153-.964-2.153-2.154V.317c.388-.039.779-.067 1.172-.088-1.884.097-3.709.414-5.454.918v20.645c0 1.19-.965 2.154-2.154 2.154s-2.153-.964-2.153-2.154V2.855C5.713 6.74.465 14.495.151 23.508v5.47c.009-.251.029-.5.045-.75h23.815c1.19 0 2.154.964 2.154 2.153 0 1.19-.964 2.153-2.154 2.153H.151v4.283h23.86c1.19 0 2.154.964 2.154 2.153s-.964 2.153-2.154 2.153H.151v4.358h23.86c1.19 0 2.154.964 2.154 2.153 0 1.19-.964 2.153-2.154 2.153H.151v4.283h23.86c1.19 0 2.154.963 2.154 2.153s-.964 2.153-2.154 2.153H.151v4.033H56.214z",
    mask: "url(#882ri3us6n)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M68.165 70.127v-.01c-.034.002-.065.01-.098.01H12.044c0 .013.002.025.003.038h56.114c0-.013.003-.025.004-.038",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M26.165 2.354l.007-.002-.007.002M25.13 2.855h.002-.003M29.435 1.147h-.002.002M27.23 1.9h.001",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y05kthhlko)",
    d: "M27.282 23.945c1.19 0 2.153-.963 2.153-2.152V1.147h-.002c-.75.217-1.483.469-2.2.754h-.002c-.358.142-.71.292-1.06.45l-.006.004c-.349.158-.693.325-1.033.5h-.003v18.938c0 1.189.964 2.152 2.153 2.152",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(35.556)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0h69xr7lsq",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n37qxoo6mp"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M.59.196H.584h.008",
    mask: "url(#0h69xr7lsq)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(34.644)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gawmbcnpus",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ejze2ksbdr"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M.246.23C.258.228.27.226.281.226L.246.229",
    mask: "url(#gawmbcnpus)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#yo4rlvrxet)",
    d: "M33.718 21.792c0 1.19.964 2.153 2.153 2.153 1.19 0 2.153-.963 2.153-2.153V.197H36.14c-.407 0-.812.01-1.215.03l-.034.002c-.393.02-.784.05-1.172.088v21.475z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M54.16 2.406l.005.002-.005-.002M53.1 1.948",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#puxnevik0u)",
    d: "M53.049 23.945c1.188 0 2.153-.963 2.153-2.152V2.917c-.34-.178-.686-.347-1.037-.509l-.005-.002c-.35-.16-.702-.314-1.06-.458-.719-.29-1.454-.546-2.204-.767v20.612c0 1.189.963 2.152 2.153 2.152",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zqdwwatawv)",
    d: "M38.017 47.634c0-1.19-.965-2.153-2.153-2.153h-23.86v4.306h23.86c1.188 0 2.153-.964 2.153-2.153M38.017 56.223c0-1.19-.965-2.154-2.153-2.154h-23.86v4.307h23.86c1.188 0 2.153-.964 2.153-2.153",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#yj39lwbxyw)",
    d: "M38.017 30.381c0-1.189-.965-2.153-2.153-2.153H12.048c-.017.25-.036.499-.045.75v3.556h23.86c1.19 0 2.154-.963 2.154-2.153",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zqdwwatawv)",
    d: "M38.017 38.97c0-1.19-.965-2.153-2.153-2.153h-23.86v4.306h23.86c1.188 0 2.153-.964 2.153-2.153",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj72msesfx)",
    d: "M42.307 47.634c0 1.189.964 2.153 2.153 2.153h23.705V45.48H44.46c-1.19 0-2.153.964-2.153 2.153M42.307 56.223c0 1.189.964 2.153 2.153 2.153h23.705v-4.307H44.46c-1.19 0-2.153.965-2.153 2.154",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M68.205 28.979c-.008-.229-.025-.455-.04-.681v.68h.04z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2hvmhbuegy)",
    d: "M44.46 28.228c-1.19 0-2.153.964-2.153 2.153 0 1.19.964 2.153 2.153 2.153h23.704V28.298c0-.023-.002-.046-.004-.07h-23.7z",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(43.76)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w5o43er30A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k8cuux369z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M.301.196c.43 0 .858.012 1.282.035C1.16.21.731.196.301.196z",
    mask: "url(#w5o43er30A)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(44.672)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "feu1q2wnuC",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0a0xxsoahB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#454645",
    d: "M.693.233L.672.23l.021.002",
    mask: "url(#feu1q2wnuC)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj72msesfx)",
    d: "M42.307 38.97c0 1.189.964 2.153 2.153 2.153h23.705v-4.306H44.46c-1.19 0-2.153.964-2.153 2.153",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jgh6vykf2D)",
    d: "M68.165 62.418c-.034-.002-.065-.01-.098-.01H12.016l-.013.001c-1.009.008-1.824.826-1.824 1.836v4.045c0 1.01.815 1.829 1.824 1.836l.013.001h56.051c.033 0 .064-.008.098-.01.968-.052 1.739-.846 1.739-1.827v-4.045c0-.98-.771-1.775-1.74-1.827",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ubgtv7dl4E)",
    d: "M36.146 92.645h7.916c12.779 0 23.233-9.921 24.099-22.48H12.047c.866 12.559 11.32 22.48 24.1 22.48",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(0 .26) translate(41.937)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gdoh6dydzH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ncj0mcfs3F"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y53p47kbzG)",
    d: "M3.428.233L3.407.23C2.982.208 2.555.196 2.124.196H.37V21.8c0 1.19.965 2.153 2.153 2.153 1.19 0 2.154-.964 2.154-2.152V.332C4.263.29 3.847.255 3.428.232",
    mask: "url(#gdoh6dydzH)"
  })))), /*#__PURE__*/React.createElement("path", {
    stroke: "#B6D9FC",
    strokeDasharray: "0 8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3,
    d: "M39.5 165v24",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49) translate(23 187)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#ohi5cnejfI)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.143 14.476h-7.62V6.857c0-.841-.682-1.524-1.523-1.524-.841 0-1.524.683-1.524 1.524v7.62H6.857c-.841 0-1.524.682-1.524 1.523 0 .841.683 1.524 1.524 1.524h7.62v7.619c0 .841.682 1.524 1.523 1.524.841 0 1.524-.683 1.524-1.524v-7.62h7.619c.841 0 1.524-.682 1.524-1.523 0-.841-.683-1.524-1.524-1.524",
    transform: "rotate(-45 16 16)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B6D9FC",
    strokeDasharray: "0 8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3,
    d: "M39.5 224v24",
    transform: "translate(-18 -141) translate(16 141) translate(83 35) translate(49)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microphone.e702e72a.svg";
export { ForwardRef as ReactComponent };